export const submitFeedback = () => /* GraphQL */ `
  mutation SubmitFeedback($input: SubmitFeedbackInput!) {
    submitFeedback(input: $input) {
      __typename
      ... on SubmitFeedbackSuccessResponse {
        message
      }
      ... on SubmitFeedbackErrorResponse {
        error
      }
    }
  }
`;
